var filterAttributes = {
    // Variable de stockage du timer
    timer : null,
    // Délai de déclenchement de l'action de filtrage
    delay:100,

    /**
     * Méthode qui sert à initialiser les menus déroulant qui permettant de saisir la quantité souhaité.
     * Si la quantité est plus important qu'un nombre donné, alors on transforme ce menu déroulant en un
     * champ de type « text » pour que l'internaute saississe la quantité voulue. Cette méthode a été mis
     * en place afin d'éviter des menus déroulants comportant des milliers d'options / de choix.
     * @return void
     */
    init: function(){
        var $this = this;

        // Mets au propre les data libelle clean
        // $('.filters-checkboxes ul li a label').each(function(){
        //     var $value = removeAccents($(this).attr('data-libelle-clean')).toLowerCase();
        //     $(this).attr('data-libelle-clean', $value);
        // });

        //-- Parcours tous les input de type "filtrage"
        $('.filters-checkboxes input[name="filter-attributes"]').each(function(){
            // Annule un éventuel appui sur la touche entrée
            $(this).on('keydown', function(e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    return false;
                }
            });

            // Déclenche l'action de filtrage au levé de la touche.
            $(this).on('keyup', function() {
                var $inputChanged = $(this);
                clearTimeout($this.timer);
                $this.timer = setTimeout(function(){
                    $this.filterAttributes($inputChanged);
                }, $this.delay);
            });
        });

        //-- Parcours tous les boutons de type "filtrage"
        $('.filters-checkboxes button.search-btn').each(function(){
            $(this).on('click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                return false;
            });
        });
    },

    /**
     * Sert à filtrer les attributs liés au champ dans lequel l'utilisateur à saisi des caractères.
     * @param Object $inputChanged object Champ modifié
     * @return void
     */
    filterAttributes : function($inputChanged) {
        var value = $inputChanged.val().trim();
        // var $li = $inputChanged.closest('ul').find('li:not(.search)');
        var $li = $inputChanged.closest('div:not(.search)').find('li:not(.search)');

        // Si aucune valeur renseignée, on affiche tous les champs
        if (!value) {
            $li.show();
            return;
        }

        // Sinon on crée la "requête" de filtration jQuery en séparant chaque mot
        // var valueWords = removeAccents(value).toLowerCase().split(' ');
        var valueWords = value.toLowerCase().split(' ');
        var containsString = '';
        for (var i in valueWords) {
            containsString += '[data-libelle-clean*="'+valueWords[i]+'"]';
        }

        // On affiche les li concernées et on masque les autres
        $li.hide();
        $li.has('label'+containsString).show();
        console.log('label'+containsString);
    }
};

(function ($) {
    filterAttributes.init();
})(jQuery);